export default "__VITE_ASSET__Cx2h9oxg__"